module.exports = __webpack_public_path__ + "assets/img/16_1790_big.a3fa2fb2.jpg";